import React, { useState } from "react";
import { useField } from "formik";
import "./CustomInput.css";
import human from "../../images/icons/human.png";
import eye from "../../images/icons/eye.png";
import eveslash from "../../images/icons/eveslash.png";

const CustomInput = (props) => {
  const [field, meta, helpers] = useField(props);
  const hasError = meta.touched && meta.error;
  const { value } = meta;
  const [showPassword, setShowPassword] = useState(false);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setShowPassword(true);
    }
  };
  return (
    <div
      className={`input_wrapper ${hasError ? "input_wrapper has_error" : ""}	${props.customclass
        } `}
    >
      {props.label && (
        <label
          style={{ color: props.labelColor }}
          className="label"
          htmlFor={props.name}
        >
          {props.label}
        </label>
      )}

      <div className="input overflowHidden">
        {props.textarea ? (
          <textarea
            name={props.name}
            className="inputBox"
            // defaultValue={props.defaultValue ? props.defaultValue : ""}
            value={value || props.initialvalue || ""}
            onChange={(e) => {
              e.stopPropagation();
              let value = e.target.value;
              if (props.format) {
                value = props.format(value) || "";
              }
              if (!!props.counter && props.counter < value.length) {
                return;
              }
              if (props.onChange) props.onChange(value);
              helpers.setValue(value);
            }}
            {...field}
            {...props}
            autoComplete="off"
            placeholder={props.placeholder}
          >
          </textarea>
        ) : (
          <>
            <input
              className={`inputBox ${props.icontext && `input-right-side_text`
                }`}
              disabled={props.disable || props.disabled}
              {...field}
              {...props}
              onChange={(e) => {
                e.stopPropagation();
                let value = e.target.value;
                if (props.format) {
                  value = props.format(value) || "";
                }
                if (!!props.counter && props.counter < value.length) {
                  return;
                }
                if (props.onChange) props.onChange(value);
                helpers.setValue(value);
              }}
              min={0}
              value={value || props.initialvalue || ""}
              id={props.name}
              type={showPassword ? "text" : props.type}
              style={{
                paddingRight: props.counter && "70px",
                height: `${props.height ? props.height : ""}`,
                fontSize: props.font_size || undefined,
              }}
              autoComplete="off"
              placeholder={props.placeholder}
            />
            {props.icontext && (
              <div className="right-side_text">{props.icontext}</div>
            )}
            {props.type !== "password" && props.hideicon !== "true" && (
              <img src={human} className="right-side_icon" alt="" />
            )}
            {props.type === "password" &&
              (showPassword ? (
                <img
                  src={eveslash}
                  onClick={() => setShowPassword(false)}
                  onKeyDown={handleKeyDown}
                  className="right-side_icon"
                  alt=""
                />
              ) : (
                <img
                  src={eye}
                  onClick={() => setShowPassword(true)}
                  onKeyDown={handleKeyDown}
                  className="right-side_icon"
                  alt=""
                />
              ))}
          </>
        )}

        {props.counter && (
          <span
            className={`${field.value.length === props.counter && "counter_error"
              } counter`}
          >
            {field.value.length} / {props.counter}
          </span>
        )}
      </div>
      {hasError ? (
        <div className="error__text">{props.customError || meta.error}</div>
      ) : null}
    </div>
  );
};

export default CustomInput;
